export enum BdtResources {
  Vehiculos = 1,
  Maquinas = 3,
  Perifericos = 4,
  Gls = 5,
  Sensores = 6,
  Software = 7,
  MandosIntermedios = 8,
  Encargados = 9,
  Empleados = 10,
  Edificios = 116,
  Servicios = 141
}
